// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","links":"Navbar_links__GNnVc","logo":"Navbar_logo__jA5Pb","rsvp":"Navbar_rsvp__chA9U","other":"Navbar_other__VzjBI"};